import { useShoolYearsQuery } from "../../family/hooks/useShoolYearsQuery"

export const useSchoolYearMenuItems = () => {
    const { data } = useShoolYearsQuery()
    return [{ id: 0, label: "School year", value: "ALL" }].concat(data.response);
}